export default "* Fisk\n* Bål\n* Jægerstenaldermad\n* Jæger/samler";